import AssociationSpec from 'automation-ui-associations/records/AssociationSpec';
const RADIX = 10;
export default function getSpecFromFullAssociationTypeIdString(stringForSpec) {
  if (!stringForSpec) {
    return null;
  }
  const [typeIdString, category] = stringForSpec.split('--');
  if (!typeIdString || !category || !parseInt(typeIdString, RADIX)) {
    return null;
  }
  return new AssociationSpec({
    associationTypeId: parseInt(typeIdString, RADIX),
    associationCategory: category
  });
}